import { preprocess } from '@artica/assets';
import { RepeatWrapping } from 'three';

preprocess('path_extrude', function preprocessPathExtrude(pathextrude) { 
  const geom = pathextrude.nodes.Sweep.geometry;
  geom.scale(0.006, 0.006, 0.02);
  geom.rotateY(-Math.PI / 2);

  return pathextrude;
});

preprocess('extrude_map', function preprocessExtrudeMap(extrudemap) { 
  extrudemap.wrapS = extrudemap.wrapT = RepeatWrapping;

  return extrudemap;
});